interface DashboardIconProps {
  className?: string;
  size?: number;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function DashboardIcon({ className = '', size = 24, color = 'white' }: DashboardIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.7949 18.2041C20.2343 18.6431 20.2352 19.3553 19.7964 19.7949C19.3575 20.2343 18.6452 20.2349 18.2056 19.7964L19.7949 18.2041ZM14.8745 12.0005C14.8745 11.5126 14.7541 11.0558 14.542 10.6558C14.0579 9.74319 13.1004 9.12518 12.0005 9.125C10.4127 9.125 9.125 10.4127 9.125 12.0005C9.12526 13.5881 10.4128 14.8745 12.0005 14.8745C13.5879 14.8742 14.8742 13.5879 14.8745 12.0005ZM19.9736 6.50586C20.5226 6.21523 21.2033 6.42435 21.4941 6.97314C21.7847 7.52205 21.5755 8.20276 21.0269 8.49365L19.9736 6.50586ZM17.1245 12.0005C17.1244 13.0089 16.8322 13.9484 16.3291 14.7412L19.7949 18.2041L18.9995 18.9995L18.2056 19.7964L14.7368 16.332C13.9449 16.8334 13.007 17.1244 12.0005 17.1245C9.17019 17.1245 6.87526 14.8307 6.875 12.0005C6.875 9.5564 8.58603 7.51213 10.8755 6.99951V2C10.8755 1.37868 11.3792 0.875 12.0005 0.875C12.6216 0.875264 13.1255 1.37884 13.1255 2V6.99951C14.2221 7.24534 15.1837 7.8436 15.8896 8.6665L19.9736 6.50586L20.4995 7.50049L21.0269 8.49365L16.9429 10.6558C17.0594 11.085 17.1245 11.5358 17.1245 12.0005Z"
        fill={color}
      />
      <path
        d="M20.8745 12.0005C20.8745 7.09912 16.9018 3.12526 12.0005 3.125C7.09896 3.125 3.125 7.09896 3.125 12.0005C3.12526 16.9018 7.09912 20.8745 12.0005 20.8745C16.9016 20.8742 20.8742 16.9016 20.8745 12.0005ZM23.1245 12.0005C23.1242 18.1443 18.1443 23.1242 12.0005 23.1245C5.85648 23.1245 0.875264 18.1444 0.875 12.0005C0.875 5.85632 5.85632 0.875 12.0005 0.875C18.1444 0.875264 23.1245 5.85648 23.1245 12.0005Z"
        fill={color}
      />
    </svg>
  );
}
